import location from '@/api/location'

export default {
  searchLocation ({ commit }, payload) {
    return location.searchLocation(payload)
      .then(response => {
        if (response && response.status === 200 && response.data.status === true) {
          return response.data.data
        }
      })
  },
  searchCities ({ state, commit }, payload) {
    return location.searchCities(payload)
      .then(response => {
        if (response && response.status === 200 && response.data.status === true) {
          commit('SET_CITIES_BY_COUNTRY_DATA', response.data.data)
          return state.citiesByCountry
        }
      })
  },
  getCountries ({ commit }, payload) {
    const countries = JSON.parse(localStorage.getItem('edit/countries'))
    if (countries && Array.isArray(countries) && countries.length > 0) {
      return false
    }
    return location.getCountries()
      .then(response => {
        if (response && response.status === 200 && response.data.status === true) {
          commit('SET_COUNTRIES_DATA', response.data.data)
          return true
        }
      })
  }
}
